import type { Project } from "../types";
import type { ReactNode } from "react";

interface Props {
  projects: Project[];
  currentProjectId: string | null;
  onPick: (projectId: string | null) => void;
  action: ReactNode;
}

export function Header({ projects, currentProjectId, onPick, action }: Props) {
  const active = projects.filter((p) => !p.archived);
  const archived = projects.filter((p) => p.archived);
  const today = new Date().toLocaleDateString(undefined, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div className="bar">
      <div className="bar__left">
        <span className="title">Task dashboard</span>
        <span className="date">{today}</span>
      </div>
      <div className="bar__right">
        <label className="sr" htmlFor="picker">
          Project
        </label>
        <select
          className="button"
          id="picker"
          value={currentProjectId ?? ""}
          onChange={(e) => onPick(e.target.value || null)}
        >
          <option value="">All projects</option>
          {active.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
          {archived.length > 0 && (
            <optgroup label="Archived">
              {archived.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </optgroup>
          )}
        </select>
        {action}
      </div>
    </div>
  );
}
